import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CheckoutProduct } from 'src/app/features/property-upload-wizard/step-four/product-card/product-card.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { AutocompleteBaseComponent } from "../../autocomplete/autocomplete-base.component";

@Component({
  selector: 'app-package',
  standalone: true,
  imports: [CommonModule, TranslocoDirective, AutocompleteBaseComponent],
  templateUrl: './package.component.html',
  styleUrl: './package.component.css'
})
export class PackageComponent {

  @Input() selectedProducts?: CheckoutProduct[]
  displayState: { [productName: string]: boolean } = {};

  toggleContent(productName: string): void {
    this.displayState[productName] = !this.displayState[productName];
  }

  isContentDisplayed(productName: string): boolean {
    return !!this.displayState[productName];
  }

  getPricingDescription(sku: string) {
    if (sku === '0001') {
      return "listingPreviewHeaders.basic"
    }
    if (sku === '0006') {
      return 'listingPreviewHeaders.photography'
    }
    return "listingPreviewHeaders.generic"
  }

  getFinalProductPrice(price: number, discount: number): number {
    if (discount > 0) {
      return Math.max(price - discount, 0);
    }
    return price;
  }

  getTotalAmountWithDiscounts(products: CheckoutProduct[]): number {
    return products.reduce((total, product) => {
      const finalPrice = this.getFinalProductPrice(product.unitPrice || 0, product.discount || 0);
      return total + finalPrice;
    }, 0);
  }

  getTotalAmount(products: CheckoutProduct[]): number {
    return products.reduce((total, product) => {
      const finalPrice = this.getFinalProductPrice(product.unitPrice || 0, 0);
      return total + finalPrice;
    }, 0);
  }

  displayTotalDiscount(products?: CheckoutProduct[]): boolean {
    const totalDiscount = products?.reduce((total, product) => total + (product.discount ?? 0), 0) ?? 0;
    return totalDiscount > 0
  }
}
